<template>
  <TransitionRoot appear :show="preview_widget_modal" as="template">
    <Dialog
      as="div"
      @close="preview_widget_modal = false"
      class="relative z-50"
    >
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-25 z-50" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto z-[9999]">
        <div
          class="flex min-h-full items-center justify-center p-4 text-center"
        >
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="w-full max-w-3xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all"
            >
              <DialogTitle>
                <div
                  class="flex justify-between items-center absolute top-4 right-4"
                >
                  <button
                    @click="preview_widget_modal = false"
                    class="flex items-center justify-center ml-auto p-2"
                  >
                    <XIcon />
                  </button>
                </div>
              </DialogTitle>
              <div class="flex items-center gap-2">
                <PartialsIframeWidget class="flex-shrink-0">
                  <iframe
                    :src="runtimeConfig.public.explore_url + '/' + widget.slug"
                    width="100%"
                    height="100%"
                    frameborder="0"
                  ></iframe>
                </PartialsIframeWidget>
                <div
                  class="text-center px-2 flex flex-col justify-center items-center w-full"
                >
                  <div class="mb-12">
                    <img
                      :src="'https://cdn.qrdove.com/' + widget.image"
                      class="w-40"
                      alt="preview-qrcode"
                    />
                    <p class="text-center font-bold">{{ $t("preview") }}</p>
                  </div>
                  <div class="flex items-center mb-6">
                    <img
                      :src="
                        'https://cdn.qrdove.com/explores/' +
                        widget.type_explore.icon
                      "
                      class="w-8 mr-2"
                      :alt="widget.type_explore.title"
                    />
                    <h3 class="text-lg leading-6 text-gray-900">
                      {{ widget_content.label || widget.name }}
                    </h3>
                  </div>
                  <p>
                    {{
                      widget_content.description ||
                      widget.type_explore.description
                    }}
                  </p>
                  <a
                    target="_blank"
                    :href="
                      'https://app.qrdove.com/sign-up?createSample=' +
                      widget.uuid
                    "
                    rel="nofollow"
                    class="bg-success h-[44px] px-10 rounded-full mt-5 text-white text-center flex items-center justify-center mx-auto"
                  >
                    {{ $t("create_qr_code") }}
                  </a>
         
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import { XIcon } from "vue-tabler-icons";
interface ExploreType {
  type_explore: {
    id: number;
    title: string;
    description: string;
    group_explore_id: number;
    icon: string;
    status: number;
    full_widget: number;
  };
  name: string;
  image: string;
  uuid: string;
  slug: string;
}
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/vue";
import { useQrCreateStore } from "~~/stores/qrcreate";
import { storeToRefs } from "pinia";
import { notify } from "@kyvg/vue3-notification";
const { preview_widget_modal } = storeToRefs(useQrCreateStore());
const props = defineProps({
  widget: {
    type: Object as () => ExploreType,
    required: true,
  },
  widget_content: {
    type: Object as () => { label: string; description: string },
    default: {
      label: "",
      description: "",
    },
  },
});
const runtimeConfig = useRuntimeConfig();
</script>
